import { ManuteRequestConfig } from '@/api/types';
import { CategoryQueryParams, CategoryRequest } from '@/api/requests/article/types';

/**
 * Request to find all categories.
 * @param params
 */
export const ALL = (params?: CategoryQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/categories',
    params: {
        ...params,
    },
});

/**
 * Request to save a new category.
 * @param data
 */
export const STORE = (data: CategoryRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/categories',
    data,
});

/**
 * Request to find a category by id.
 * @param categoryId
 */
export const FIND = (categoryId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/categories/${categoryId}`,
});

/**
 * Request to update an existing category.
 * @param categoryId
 * @param data
 */
export const UPDATE = (categoryId: number, data: CategoryRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/categories/${categoryId}`,
    data,
});

/**
 * Request to delete a category by id.
 * @param categoryId
 */
export const DELETE = (categoryId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/categories/${categoryId}`,
});
